import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  styled,
  Dialog,
  TextField,
  FormControl,
  InputLabel,
  OutlinedInput,
  InputAdornment,
  Typography,
} from "@mui/material";
import PropTypes from "prop-types";
//import { submitTableOrder } from "../apis/RangerOnlineApi";
import { AlertPopUp } from "../components/AlertPopUp";
import { TableOrderSummary } from "../components/TableOrderSummary";
import { useNavigate } from "react-router-dom";
import { PlaceOrderTypeDialog } from "./PlaceOrderTypeDialog";
import { calculateOrderTotal } from "../Utils/utils";
import { CheckOutInfoDialog } from "./CheckOutInfoDialog";
import { UpSellItemCategoryDialog } from "./UpSellItemCategoryDialog";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

const BootstrapDialogTitle = (props) => {
  const { children, name, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {name}
    </DialogTitle>
  );
};

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
};

const stripeEnabled = false;

export const CheckOutDialogTableOrder = (props) => {
  let navigate = useNavigate();
  const {
    user,
    onClose,
    onRemove,
    open,
    orders,
    taxes,
    onEdit,
    orderType,
    deliveryCharge,
    onOrderSelection,
    companyName,
    pickUpTime,
    deliveryTime,
    editOrder,
    enablePromoCode,
    onPromoCode,
    promoCode,
    choiceItemsCategories,
    serviceCharges,
    ApplyTakeOutDeliveryPrice,
    settings,
    companyData,
  } = props;
  const [order, setOrder] = useState({});
  const [paymentOpen, setPaymentOpen] = useState(false);
  const [loader, setLoader] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [upSoldItem, setUpSoldItem] = useState(false);
  const {
    AllowDiscountOnDelivery,
    AllowDiscountOnPickup,
    OnlineSpecialDiscount,
    MinimumDeliveryOrder,
    MinimumDeliveryOrderAmt,
  } = settings;
  const showLoader = () => {
    setLoader(true);
  };

  const hideLoader = () => {
    setLoader(false);
  };

  const handleNumberCharge = (e) => {
    let orderCopy = { ...order };
    const target = e.target;
    orderCopy[target.id] = target.value;

    setOrder(orderCopy);
  };

  const handlePromoCode = async () => {
    try {
      const element = document.getElementById("promoCodeDialog");
      onPromoCode(element.value);
    } catch (error) {
      alert("error");
    }
  };

  const handleTip = (value, type) => {
    let orderCopy = { ...order };
    if (orderCopy.tip) {
      orderCopy.orderTotal = orderCopy.orderTotal - orderCopy.tip;
    }
    if (type === "percentage") {
      orderCopy.tip =
        Math.round(
          (orderCopy.subTotal * (value / 100) + Number.EPSILON) * 100
        ) / 100;
    } else {
      orderCopy.tip =
        Math.round(
          (parseFloat(value.target.value == "" ? 0 : value.target.value) +
            Number.EPSILON) *
            100
        ) / 100;
    }
    orderCopy.orderTotal = orderCopy.orderTotal + orderCopy.tip;
    setOrder({ ...orderCopy });
  };

  const handleDeliveryCharge = (value, type) => {
    let orderCopy = { ...order };
    orderCopy.deliveryCharge = value;

    orderCopy.orderTotal = orderCopy.orderTotal + orderCopy.deliveryCharge;
    setOrder({ ...orderCopy });
  };

  const handleCustomerData = (customerData) => {
    let orderCopy = { ...order };
    Object.assign(orderCopy, customerData);
    setOrder(orderCopy);
  };

  useEffect(() => {
    const order = calculateOrderTotal({
      editOrder,
      orderType,
      user,
      orders,
      deliveryCharge,
      taxes,
      promoCode,
      serviceCharges,
      ApplyTakeOutDeliveryPrice,
      AllowDiscountOnDelivery,
      AllowDiscountOnPickup,
      OnlineSpecialDiscount,
    });
    setOrder(order);
  }, [orders, promoCode]);
  return (
    <BootstrapDialog
      keepMounted={false}
      aria-labelledby="customized-dialog-title"
      open={open}
      maxWidth={"md"}
      fullWidth={true}
    >
      {open ? (
        <>
          <BootstrapDialogTitle
            id="customized-dialog-title"
            name={"Order Summary:"}
          />
          <DialogContent dividers>
            <Box
              display={"flex"}
              justifyContent={"center"}
              alignItems={"center"}
              flexDirection="column"
              // height={"385px"}
            >
              <TableOrderSummary
                order={order}
                taxes={taxes}
                onEdit={onEdit}
                onRemove={onRemove}
                ApplyTakeOutDeliveryPrice={ApplyTakeOutDeliveryPrice}
              />
            </Box>
            <Box sx={{ width: { xs: "100%", sm: "279px" } }}>
              {order.orderType === "Delivery" ? (
                <TextField
                  id="deliveryCharge"
                  type="number"
                  label="Delivery Charge:"
                  variant="outlined"
                  fullWidth
                  disabled
                  inputProps={{ pattern: "d+(.d*)?", inputMode: "numeric" }}
                  sx={{ marginTop: "10px", marginRight: "10px" }}
                  onChange={handleNumberCharge}
                  value={order.deliveryCharge}
                />
              ) : null}

              {enablePromoCode == "1" ? (
                <FormControl
                  fullWidth
                  sx={{
                    marginTop: "10px",
                    /*border: "2px solid",
                  borderRadius: "5px",*/
                    marginRight: "5px",
                  }}
                  disable={order?.promoCode}
                >
                  <InputLabel htmlFor="promoCodeDialog">Promo Code</InputLabel>
                  <OutlinedInput
                    id="promoCodeDialog"
                    endAdornment={
                      <InputAdornment position="end">
                        <Button variant="outlined" onClick={handlePromoCode}>
                          Apply
                        </Button>
                      </InputAdornment>
                    }
                    label="Apply Promo Code"
                  />
                </FormControl>
              ) : null}
            </Box>
            {paymentOpen && upSoldItem ? (
              <CheckOutInfoDialog
                open={paymentOpen}
                onClose={() => setPaymentOpen(false)}
                onOrderSelection={onOrderSelection}
                companyName={companyName}
                deliveryCharge={deliveryCharge}
                pickUpTime={pickUpTime}
                deliveryTime={deliveryTime}
                order={order}
                onTipChange={handleTip}
                handleDeliveryCharge={handleDeliveryCharge}
                saveCustomerData={handleCustomerData}
                orderType={orderType}
                taxes={taxes}
                settings={settings}
                companyData={companyData}
              />
            ) : null}
            {paymentOpen && !upSoldItem ? (
              <UpSellItemCategoryDialog
                open={paymentOpen}
                onClose={() => {
                  setPaymentOpen(false);
                  setUpSoldItem(true);
                }}
                onNo={() => setUpSoldItem(true)}
                choiceItemsCategories={choiceItemsCategories}
                onProductClick={onEdit}
                onUpsellItem={() => setUpSoldItem(true)}
              />
            ) : null}
            {orderType === "Delivery" &&
            MinimumDeliveryOrder == 1 &&
            order.orderTotal < MinimumDeliveryOrderAmt ? (
              <Typography>{`You must order items worth $${MinimumDeliveryOrderAmt} for delivery`}</Typography>
            ) : null}
          </DialogContent>
          <DialogActions
            sx={{ display: "flex", justifyContent: "space-between" }}
          >
            <Button
              variant="outlined"
              color="error"
              autoFocus
              onClick={onClose}
            >
              Cancel
            </Button>

            <Button
              autoFocus
              variant="contained"
              onClick={() => setPaymentOpen(true)}
              disabled={
                !(orders.length > 0) ||
                (orderType === "Delivery" &&
                  MinimumDeliveryOrder == 1 &&
                  order.orderTotal < MinimumDeliveryOrderAmt)
              }
            >
              Place order
            </Button>
          </DialogActions>
        </>
      ) : null}
    </BootstrapDialog>
  );
};
